<template>
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical form">
    <EmployeeFormFields
      :employee="employee"
      @submitted="onSubmitted"
      formName="従業員"
      :api="save"
      :title="employee && employee.id ? '従業員編集' : '新規追加'"
    />
  </div>
</template>
<style lang="scss" scoped>
div.uk-modal-dialog {
  width: unset;
}
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { CreateEmployee, Employee, EmployeeApi, UpdateEmployee } from "../../autogen";
import EmployeeFormFields from "../molecules/EmployeeFormFields.vue";
@Options({
  components: {
    EmployeeFormFields
  }
})
export default class EmployeeForm extends FormMixin {
  @Prop({ type: Object }) employee?: Employee;
  @Emit("submitted")
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSubmitted() {}
  async save(values: CreateEmployee | UpdateEmployee) {
    if (this.employee?.id) {
      await new EmployeeApi().updateEmployee({
        departmentId: this.employee.departmentId,
        employeeId: this.employee.id,
        body: values
      });
    } else {
      await new EmployeeApi().createEmployee({
        departmentId: this.$route.params["departmentId"] as string,
        body: values
      });
    }
  }
}
</script>
